import { render, staticRenderFns } from "./apartment-location-heading.vue?vue&type=template&id=5dbc7784&"
import script from "./apartment-location-heading.ts?vue&type=script&lang=ts&"
export * from "./apartment-location-heading.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-location-heading.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports